/* eslint-disable */
import Vue from 'vue';
import Vuex from 'vuex';
import { fetchSessionUser } from '@/api/docs';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  state: {
    session: {},
    toastr: {},
    googleUser: {},
    searchSettings: {},
    searchtext: '',
    pageLayout: 'plain',
    showFilters: false,
    gAPIError: false,
    mainLoading: true,
    errorCode: false,
  },
  getters: {
    isLoggedIn: state => !!state.googleUser.token,
    isAuthorized: state => !!state.session.searchKey,
    searchKey: (state, getters, rootState) => state.session.searchKey,
  },
  mutations: {
    SET_SESSION: (state, newValue) => {
      state.session = newValue;
    },
    SET_GAPIERROR: (state, newValue) => {
      state.gAPIError = newValue;
    },
    SET_GOOGLE_USER: (state, newValue) => {
      state.googleUser = newValue;
    },
    SET_SEARCH_SETTINGS: (state, newValue) => {
      state.searchSettings = newValue;
    },
    SET_LAYOUT: (state, newValue) => {
      state.pageLayout = newValue;
    },
    TOGGLE_FILTER: (state, newValue) => {
      state.showFilters = newValue;
    },
    TOGGLE_LOADER: (state, newValue) => {
      state.mainLoading = newValue;
    },
    SET_TOASTR: (state, newValue) => {
      state.toastr = newValue;
    },
    SET_ERROR: (state, newValue) => {
      state.errorCode = newValue;
    },
    UPDATE_SEARCH_TEXT: (state, newValue) => {
      state.searchtext = newValue;
    },
  },
  actions: {
    loadSessionData({ commit, state }) {
      return new Promise(resolve => {
        let checkGauthLoad = setInterval(() =>{
          commit('TOGGLE_LOADER', true);
          commit('SET_ERROR', false);
          var _this = this._vm;
          _this.isInit = _this.$gAuth.isInit;
          if(!_this.isInit) return;
          clearInterval(checkGauthLoad);

          if(!_this.$gAuth.isAuthorized){
            commit('SET_GOOGLE_USER', {});
            commit('SET_SESSION', {});
            commit('SET_GAPIERROR', false);
            if(_this.$gAuth.error){
              if(_this.$gAuth.error.error && _this.$gAuth.error.error == 'idpiframe_initialization_failed') {
                commit('SET_ERROR', 400);
                commit('SET_GAPIERROR', true);
              }
              else {
                commit('SET_ERROR', 403);
              }
            }
            resolve();
          }
          else {
            var currentUser = _this.$gAuth.GoogleAuth.currentUser.get();
            const userEmail = currentUser.getBasicProfile().getEmail();
            const id_token = currentUser.getAuthResponse().id_token;
            commit('SET_GOOGLE_USER', {mail: userEmail, token: id_token});
            fetchSessionUser(id_token).then((response) => {
              if(response.status != 200 || !response.data.email || response.data.email !== userEmail){
                commit('SET_SESSION', {});
                commit('SET_ERROR', 403);
                resolve();
              }
              commit('SET_SESSION', response.data);
              resolve();
            }).catch((error) => {
              commit('SET_ERROR', error.response.status);
              resolve();
            });
          }
        }, 1000);
      });
    },
    setSession: ({ commit, state }, newValue) => {
      commit('SET_SESSION', newValue);
      return state.session;
    },
    setSearchSettings: ({ commit, state }, newValue) => {
      commit('SET_SEARCH_SETTINGS', newValue);
      return state.searchSettings;
    },
    setLayout: ({ commit, state }, newValue) => {
      commit('SET_LAYOUT', newValue);
      return state.pageLayout;
    },
    setError: ({ commit, state }, newValue) => {
      commit('SET_ERROR', newValue);
      return state.errorCode;
    },
    toggleFilter: ({ commit, state }, newValue) => {
      commit('TOGGLE_FILTER', newValue);
      return state.showFilters;
    },
    toggleLoader: ({ commit, state }, newValue) => {
      commit('TOGGLE_LOADER', newValue);
      return state.mainLoading;
    },
    setToastr: ({ commit, state }, newValue) => {
      commit('SET_TOASTR', newValue);
      return state.toastr;
    },
    updateSearchText: ({ commit, state }, newValue) => {
      commit('UPDATE_SEARCH_TEXT', newValue);
      return state.searchtext;
    },
  },
  strict: debug,
});
